import { render, staticRenderFns } from "./cowWeightGainShedWise.vue?vue&type=template&id=04e37c6d&scoped=true&"
import script from "./cowWeightGainShedWise.vue?vue&type=script&lang=js&"
export * from "./cowWeightGainShedWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e37c6d",
  null
  
)

export default component.exports